<template>
  <div class="wrap">
    <i class="el-icon-warning icon"></i>
    <div><slot name="default"></slot></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {},
  setup() {},
});
</script>

<style lang="scss" scoped>
.wrap {
  border: 1px solid var(--primary);
  background: rgba(34, 132, 254, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: var(--fs-md);
  line-height: var(--lh-md);
  padding: 10px 12px;
  color: var(--g1);
}
.icon {
  color: var(--primary);
  font-size: var(--fs-lg);
  margin-right: 8px;
  flex-shrink: 0;
}
</style>
